<!--
 * @Description  : 平台技术服务权益
 * @Author       : git config user.sname
 * @Date         : 2025-12-26 14:46:26
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-12-29 14:00:55
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\commodity-management\product-list\components\platformRights.vue
-->
<template>
	<div class="platformRights">
		<el-form
			class="tableForm"
			size="medium"
			ref="rightsObjRfe"
			label-width="110px"
			:model="rightsObj"
			:show-message="false"
			:disabled="isDiabled"
		>
			<el-form-item label="项目绑定限制" prop="bindLimit" :rules="requiredRule">
				<el-input placeholder="请输入" v-model="rightsObj.bindLimit" @input="moneyCheck($event, 'rightsObj', 'bindLimit')" :maxlength="10">
					<template slot="append">个</template>
				</el-input>
			</el-form-item>
			<el-form-item label="权益有效期" prop="validDay">
				<el-input
					placeholder="请输入"
					v-model="rightsObj.validDay"
					@input="moneyCheck($event, 'rightsObj', 'validDay')"
					:maxlength="10"
					v-if="formObj.feeType == '0'"
				>
					<template slot="append">天</template>
				</el-input>
				<el-input placeholder="请输入" v-model="rightsObj.validDay" disabled v-else> </el-input>
			</el-form-item>
			<el-form-item label="招标人业务分析报告数" prop="reportNum" class="label-class">
				<el-input placeholder="请输入" v-model="rightsObj.reportNum" @input="moneyCheck($event, 'rightsObj', 'reportNum')" :maxlength="10">
					<template slot="append">个</template>
				</el-input>
			</el-form-item>
			<el-form-item label="是否开通服务号通知" prop="isOpen" class="label-class">
				<el-select v-model="rightsObj.isOpen" size="small">
					<el-option :value="1" label="是"></el-option>
					<el-option :value="0" label="否"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
import { mapState } from "vuex";

export default {
	props: {
		formObj: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			isDiabled: false, //禁止编辑
			rightsObj: {
				bindLimit: '',
				isOpen: '',
				validDay: '',
				reportNum:''
			},
			requiredRule: [{ required: true, message: '', trigger: ['change', 'blur'] }]
		}
	},

	methods: {
		initData(data,type) {
			this.rightsObj.bindLimit = 1
			this.rightsObj.isOpen = ''
			this.rightsObj.validDay = this.formObj.feeType == '0' ? '' : this.formObj.feeType == '1' ? '跟随项目时间' : ''
			if (data) {
				Object.keys(this.rightsObj).forEach((key) => {
					this.rightsObj[key] = data[key]
				})
				this.isDiabled = type == 'view' ? true : false
			}
		},
		//商品权益信息输入处理
		moneyCheck(value, bindForm, bindKey) {
			value = value.replace(/^0|[^0-9]/g, '')
			this.$set(this[bindForm], bindKey, value)
			return value
		},
		//赠送商品处理
		changeSelect(value) {
			let arr = []
			let newArr = [].concat(this.commodityDict.spmc)
			if (value && value.length != 0) {
				newArr.map((x) => {
					value.map((y) => {
						if (x.value == y) {
							let obj = {
								sname: x.sname,
								id: x.value,
								num: ''
							}
							arr.push(obj)
						}
					})
				})
			}

			this.rightsObj.goodsList = arr
		}
	},
	computed: {
		...mapState('dict', {
			commodityDict: (state) => state.commodityDict //商品字典
		})
	}
}
</script>
<style lang="less" scoped>
.platformRights{
    .goods-list {
        width: 100%;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .list-title {
            padding-left: 10px;
        }
        /deep/.el-input-group {
            width: 200px;
        }
        /deep/.el-input__inner,
        /deep/.el-input-group__append {
            border-radius: 0;
        }
    }
    .label-class {
        /deep/.el-form-item__label {
            line-height: unset;
        }
    }
}

</style>
